import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseService } from '@services/base-service.service';
import { UtilitiesService } from '@services/utilities.service';
import { ICardPriceSummary } from '@shared/components/card/v1/card-price-summary-v1/card-price-summary-v1.interface';

@Component({
  selector: 'app-card-price-summary-v1',
  templateUrl: './card-price-summary-v1.component.html',
  styleUrls: ['./card-price-summary-v1.component.scss'],
})
export class CardPriceSummaryV1Component implements OnInit {
  @Input() url!: string;
  @Input() showCard: boolean = true;
  @Input() showInModal: boolean = false;

  data: BehaviorSubject<ICardPriceSummary> = new BehaviorSubject<ICardPriceSummary>({} as ICardPriceSummary);
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  get dataValue(): ICardPriceSummary {
    return this.data.value;
  }

  set dataValue(val) {
    this.data.next(val);
  }

  constructor(private baseService: BaseService, public utilities: UtilitiesService) {}

  ngOnInit(): void {
    if (!!this.url) this.getData();
  }

  getData() {
    this.isLoading.next(true);
    this.baseService.getData<ICardPriceSummary>(this.url).subscribe((resp: any) => {
      if (resp && resp.success) {
        this.data.next(resp.data);
        this.isLoading.next(false);
      }
    });
  }

  protected readonly Array = Array;
}
